
import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  data: [],
  isLoading: false,
};

const productDataSlice = createSlice({
  name: 'productData',
  initialState,
  reducers: {
    setProduct: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
    },
  },
});

export const { setProduct } = productDataSlice.actions;

export default productDataSlice.reducer;

